export const storageConstants = {
  vueAppPaymentHost: 'VUE_APP_PAYMENT_HOST',
  vueAppApiHost: 'VUE_APP_API_HOST',
  naverKey: 'NAVER_KEY',
  telegramBot: 'TELEGRAM_BOT',
  telegramUrl: 'TELEGRAM_URL',
  applicationType: 'APPLICATION_TYPE',
  socialCode: 'SOCIAL_CODE',
  brandCode: 'brandCode',
  brandName: 'brandName',
  brandLogo: 'brandLogo',
  brandCompany: 'brandCompany',
  browserTitle: 'browserTitle',
  languageInfo: 'languageInfo',
  userParams: 'userParams',
  token: 'token',
  tokens: 'tokens',
  firstChar: 'firstChar',
  bgColors: 'bgColors',
  memberId: 'memberId',
  memberName: 'memberName',
  rememberUser: 'rememberUser',
  skillPathAuth: 'SKILL_PATH_AUTHORIZATION',
  idpService: 'IDP_SERVICE',
  idpServiceUrl: 'IDP_SERVICE_URL',
  idpSignOutUrl: 'IDP_SIGNOUT_URL',
  redirectPath: 'REDIRECT_PATH',
  dynamicQuery: 'DYNAMIC_QUERY',
  beforeRoute: 'learnDetails',
  UTCTime: 'UTC_TIME',
  fbToken: 'fbToken',
  permissions: 'permissions',
  appType: 'appType',
  totalLoginToken: 'totalLoginToken',
  totalLogin: 'totalLogin',
  deviceOS: 'deviceOS',
  recentSearchList: 'recentSearchList',
  learn: 'learn',
  iconify: 'iconify',
  showPopupDate: 'showPopupDate',
  checkedPopup: 'checkedPopup',
  appleUserInfo: 'appleUserInfo',
  // TASK-295: 학습자 홈 앱 전환 유도 Alert
  learnerAppInstallLink: 'learnerAppInstallLink',
};
